export interface Pagination<Content> {
  total: number
  rows: Content[]
}

export interface PaginationQuery {
  pageNum?: number
  pageSize?: number
  sort?: string
}

export const MAX_PAGE_SIZE = 10000
